import { Fragment } from "react";
import { Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { PermisoGestion } from "../services/permisos-service";
import { PermisoRow } from "./PermisoRow";

/** Agrupa los permisos por `grupo`, ordenados por nombre de grupo. */
function agrupar(permisos: PermisoGestion[]): Array<[string, PermisoGestion[]]> {
  const mapa = new Map<string, PermisoGestion[]>();
  for (const p of permisos) {
    const lista = mapa.get(p.grupo) ?? [];
    lista.push(p);
    mapa.set(p.grupo, lista);
  }
  return [...mapa.entries()].sort((a, b) => a[0].localeCompare(b[0]));
}

export function PermisosTable({ permisos }: { permisos: PermisoGestion[] }) {
  const grupos = agrupar(permisos);
  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Código</Th>
          <Th>Descripción</Th>
          <Th>Tipo</Th>
          <Th align="center">Roles</Th>
          <Th>Estado</Th>
          <Th align="right">Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {permisos.length === 0 ? (
          <Tr>
            <Td colSpan={6} align="center">
              Sin permisos.
            </Td>
          </Tr>
        ) : (
          grupos.map(([grupo, items]) => (
            <Fragment key={grupo}>
              <Tr className="bg-muted/40">
                <Td colSpan={6}>
                  <Text size="xs" fw={700} c="dimmed" tt="uppercase">
                    {grupo} · {items.length}
                  </Text>
                </Td>
              </Tr>
              {items.map((p) => (
                <PermisoRow key={p.id} permiso={p} />
              ))}
            </Fragment>
          ))
        )}
      </Tbody>
    </Table>
  );
}
